import React, { Component } from 'react';

class QuestionForm extends Component {
    state = {
        input: ''
    }

    render() {
        return (
            <div className={'question-form row'}>
                <div className="col-sm-12">
                    <div className="question-form__inner">
                        <p>We want to know the questions that are stopping you from growing.</p>
                        <p>Submit them anonymously and we will contact our community of folks to create content that answers it.</p>

                        <form
                            className="question-form__form"
                            onSubmit={e => {
                                e.preventDefault();


                            }}
                        >
                            <label htmlFor={'question-form-input'}>Ask a question:</label>
                            <input
                                value={this.state.input}
                                onChange={({ target }) => this.setState({
                                    input: target.value
                                })}
                                id={'question-form-input'}
                                type="text"
                            />

                            <button
                                className="bttn"
                                disabled={!this.state.input}
                            >Send</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuestionForm;



// WEBPACK FOOTER //
// ./src/js/components/QuestionForm.js